































































































































































































































































































































































































































































































































import {
  computed,
  defineComponent,
  onMounted,
  reactive,
  ref,
  Ref,
} from "@vue/composition-api";
import { ArticleRegistrationApi, ArticleRegistrationDto, Gender } from "@/api";
import { toLocalDateStringShort } from "@/util/date";
import { mapValidationErrors } from "@/util/Forms";

interface RequestForm {
  isValid: boolean;
  errors: {};
  fields: {
    gender: Gender;
    initials: string | null | undefined;
    firstName: string | null | undefined;
    middleName: string | null | undefined;
    lastName: string | null | undefined;
    address: string | null | undefined;
    number: string | null | undefined;
    addition: string | null | undefined;
    zipCode: string | null | undefined;
    location: string | null | undefined;
    birthDate: string | null | undefined;
    telephonePrivate: string | null | undefined;
    telephoneBusiness: string | null | undefined;
    email: string | null | undefined;
    employer: string | null | undefined;
    employerNumber: string | null | undefined;
    department: string | null | undefined;
    costPlace: string | null | undefined;
  };
}

export default defineComponent({
  setup(props, vm) {
    const articleId = Number(vm.root.$route.params.id);
    const api = new ArticleRegistrationApi();
    const articleDetails: Ref<ArticleRegistrationDto> = ref({});
    const datePickerMenu = ref(false);
    const parsedDate = ref<string | null>();
    const requestForm: RequestForm = reactive({
      isValid: false,
      errors: {},
      fields: {
        gender: ref(Gender.Unknown),
        initials: ref(""),
        firstName: ref(""),
        middleName: ref(""),
        lastName: ref(""),
        address: ref(""),
        number: ref(""),
        addition: ref(""),
        zipCode: ref(""),
        location: ref(""),
        birthDate: ref(""),
        telephonePrivate: ref(""),
        telephoneBusiness: ref(""),
        email: ref(""),
        employer: ref(""),
        employerNumber: ref(""),
        department: ref(""),
        costPlace: ref(""),
      },
    });
    const loading = ref(true);
    const loadingSave = ref(false);

    const formatDate = (d: string | null) => {
      if (!d) {
        return "";
      }
      // Format in current locale.
      return toLocalDateStringShort(d);
    };

    const birthDate = computed({
      get(): string {
        return formatDate(parsedDate.value || "");
      },
      set(value: string | null) {
        parsedDate.value = value;
      },
    });

    async function getArticleDetail() {
      return api
        .articleRegistrationGetArticleRegistration(articleId)
        .then((response) => {
          return response.data;
        });
    }

    function onSaveRequest() {
      loadingSave.value = true;

      api
        .articleRegistrationUpdateArticleRegistration({
          articleRegistrationId: articleId,
          gender: requestForm.fields.gender,
          initials: requestForm.fields.initials || "",
          firstName: requestForm.fields.firstName || "",
          middleName: requestForm.fields.middleName || "",
          lastName: requestForm.fields.lastName || "",
          birthDate: parsedDate.value || "", // Use yyyy-MM-dd format.
          street: requestForm.fields.address || "",
          houseNumber: requestForm.fields.number || "",
          zipcode: requestForm.fields.zipCode || "",
          city: requestForm.fields.location || "",
          houseNumberAddition: requestForm.fields.addition,
          phonePrivate: requestForm.fields.telephonePrivate,
          phoneBusiness: requestForm.fields.telephoneBusiness,
          employeeNr: requestForm.fields.employerNumber,
          employeeDepartment: requestForm.fields.department,
          costCenter: requestForm.fields.costPlace,
        })
        .then(() => {
          loadingSave.value = false;
          // Back to detail page.
          vm.root.$router.push({
            name: "postvak-in-detail",
            params: { id: articleId.toString() },
          });
        })
        .catch((err) => {
          requestForm.errors = err.response.data.errors;
          loadingSave.value = false;
        });
    }

    onMounted(async () => {
      articleDetails.value = await getArticleDetail();
      // Prefill the form
      requestForm.fields.gender = articleDetails.value.gender
        ? articleDetails.value.gender
        : Gender.Unknown;
      requestForm.fields.initials = articleDetails.value.initials;
      requestForm.fields.firstName = articleDetails.value.firstName;
      requestForm.fields.middleName = articleDetails.value.middleName;
      requestForm.fields.lastName = articleDetails.value.lastName;

      requestForm.fields.address = articleDetails.value.street;
      requestForm.fields.number = articleDetails.value.houseNumber;
      requestForm.fields.addition = articleDetails.value.houseNumberAddition;

      requestForm.fields.zipCode = articleDetails.value.zipcode;
      requestForm.fields.location = articleDetails.value.city;
      requestForm.fields.birthDate = articleDetails.value.birthDate;
      if (articleDetails.value.birthDate) {
        // Format from API is already yyyy-MM-dd.
        birthDate.value = articleDetails.value.birthDate.substring(0, 10);
      }
      requestForm.fields.telephonePrivate = articleDetails.value.phonePrivate;
      requestForm.fields.telephoneBusiness = articleDetails.value.phoneBusiness;
      requestForm.fields.email = articleDetails.value.emailAddress;
      requestForm.fields.employer = articleDetails.value.projectName;
      requestForm.fields.employerNumber = articleDetails.value.employeeNr;
      requestForm.fields.department = articleDetails.value.employeeDepartment;
      requestForm.fields.costPlace = articleDetails.value.costCenter;

      loading.value = false;
    });

    return {
      articleDetails,
      birthDate,
      datePickerMenu,
      requestForm,
      onSaveRequest,
      parsedDate,
      mapValidationErrors,
      toLocalDateStringShort,
      loading,
      loadingSave,
      Gender,
    };
  },
});
